module.exports = "fonts/Wrangler.woff2";